import { Checkbox, Tooltip } from '@mui/material';
import images from '../../assets/images';
import './TabsContentHeader.scss';
import { getScreenDimensions } from '../../utils/helper';
import { useEffect, useRef, useState } from 'react';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';


interface PropsType {
  title: string;
  subtitle: string;
  addLabel: string;
  setDisplayForm?: (value: boolean) => void;
  displayForm?: boolean;
  setisFullView?: (value: boolean) => void;
  isFullView?: boolean;
  handleSearchDebounce?: (value: string) => void;
  setClickAction?: (value: string) => void;
  subImage: string;
  searchValue: string;
  setSearchValue: (value: string) => void;
  tab?: string;
  handleCheckAll?: () => void;
  isSelectAllChecked?: boolean;
  setOpenSwitchClassPopup?: (val: boolean) => void;
  checkedStudents?: string[];
  handleClickBulkUpload ? : () => void;
  filterComponent?: React.ReactNode;
}

export const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

const ANNOUNCEMENT_THRESHOLD = 910;

const TabsContentHeader = ({ 
  title, 
  subtitle, 
  addLabel, 
  setDisplayForm, 
  displayForm,
  setisFullView, 
  isFullView,
  handleSearchDebounce, 
  setClickAction, 
  subImage, 
  searchValue, 
  setSearchValue, 
  tab, 
  handleCheckAll, 
  isSelectAllChecked, 
  setOpenSwitchClassPopup, 
  checkedStudents, 
  handleClickBulkUpload,
  filterComponent
}: PropsType) => {
  const { searchIcon, plusIcon, backArrow, studentCheckboxAllChecked, studentCheckboxAllOutline, ShareIconStudent, StudentShareIconMobile, searchCloseIcon } = images;
  const { isMobileScreen } = getScreenDimensions();
  const width = useWindowWidth();

  const [isSearchActive, setIsSearchActive] = useState(false);
  const searchThreshold = filterComponent ? 1392 : 1000;
  const isSearchToggleEnabled = width <= searchThreshold && width > 768;

  const searchOnChange = (event: { target: { value: string; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce){
      handleSearchDebounce(event?.target?.value);
    }
  }

  const handleShareButton = () => {
    trackButtonClick(ButtonClickEvents?.STUDENT_SHARE_BUTTON_CLICK, {
      description: "User clicks the share button"
    });
    if (checkedStudents && checkedStudents?.length > 0 && setOpenSwitchClassPopup) {
      setOpenSwitchClassPopup(true);
    }
  }
  
  const titleRef = useRef<HTMLDivElement | null>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    checkOverflow();
  }, [title]); // Recheck when the title changes

  const checkOverflow = () => {
    if (titleRef.current) {
      setIsOverflow(titleRef.current.scrollWidth > titleRef.current.clientWidth);
    }
  };

  return (
    <div className='tabsContentHeader'>
      <div className='tabsContentHeaderInnerCtn'>
        {(!isSearchActive || !isSearchToggleEnabled) ? (
          <>
            <div className={subImage === backArrow? 'tabsHeaderLeftContainerBack' : 'tabsHeaderLeftContainer'}>
              {subImage === backArrow ?
              <div 
                className='backImageContainer' 
                onClick={() => {
                  if(setDisplayForm){
                    setDisplayForm(!displayForm); 
                    if(setisFullView){ 
                      setisFullView(!isFullView);
                    }
                  }
                }}
              >
                <img src={subImage} alt='userImage' className='imageStyle' />
              </div> 
            :
              <div className='imageContainer'>
                <img src={subImage} alt='userImage' className='imageStyle' />
              </div>
              }
              <div className='labelContainer'>
                <Tooltip title={title} disableHoverListener={!isOverflow} placement="top">
                  <div
                    className="titleStyle"
                    ref={titleRef}
                  >
                    {title}
                  </div>
                </Tooltip>
                { (subImage !== backArrow || tab === "student") &&
                  <div className='subTitleStyle'>{subtitle}</div>
                }
              </div>
            </div>

            { (subImage !== backArrow || tab === "student") && (
              width > searchThreshold && (
                <div className='tabHeaderMiddleContainer'>
                  <div className='searchIconContainer'><img src={searchIcon} alt='searchIcon' className='searchIconStyle' /></div>
                  <input id="searchBox" type='text' onChange={searchOnChange} value={searchValue} placeholder='Search' className='searchInputFieldStyle' />
                </div>
              )
            )}

            {addLabel!=="" ?
            <div onClick={() => {
              if(addLabel === "Bulk Upload" && handleClickBulkUpload){
                  handleClickBulkUpload()
              }
              if (setDisplayForm) {
                setDisplayForm(!displayForm);
              }
              if (setisFullView) {
                setisFullView(!isFullView);
              }
              if (setClickAction) {
                setClickAction("add");
              }
            }}
              className='tabHeaderRightContainer'
            >
              { (subImage !== backArrow || tab === "student") && isSearchToggleEnabled && (
                <div className='searchIconOnlyContainer' onClick={(e) => {
                  e.stopPropagation();
                  setIsSearchActive(true);
                }}>
                  <img src={searchIcon} alt='searchIcon' className='searchIconStyle' />
                </div>
              )}
              {(((addLabel === "Add Annoucement") && width >= ANNOUNCEMENT_THRESHOLD) && !isMobileScreen) && <div className='addLabelStyle'>{addLabel}</div>}
              {addLabel === "Bulk Upload" &&  <div className='bulk'>Bulk Upload</div>}
              <div className='plusIconContainer'>
                <img src={plusIcon} alt="plusIcon" className='plusIconStyle' />
              </div>
            </div>
            : 
            (tab === "student") ? (
              <div className='tabHeaderRightContainer selectContainer'>
                <div className='CheckboxContainer'>
                  <div className='selectAllStyle'>Select All</div>
                  <Checkbox
                      icon={<img src={studentCheckboxAllOutline} className='mobileCheckBox' alt="Unchecked"/>}
                      checkedIcon={<img src={studentCheckboxAllChecked} alt="Checked"/>}
                      checked={isSelectAllChecked}
                      onChange={handleCheckAll}
                      className='headerCheckBox'
                  />
                </div>
                {setOpenSwitchClassPopup && (<div className='shareIconContainer' onClick={handleShareButton}>
                  <img src={isMobileScreen ? StudentShareIconMobile : ShareIconStudent} alt="plusIcon" className='shareIconStyle' />
                </div>)}
              </div>
            ) :
            filterComponent ? (
              <div className='tabHeaderRightFilterContainer'>
                { (subImage !== backArrow || tab === "student") && isSearchToggleEnabled && (
                  <div className='searchIconOnlyContainer' onClick={(e) => {
                    e.stopPropagation();
                    setIsSearchActive(true);
                  }}>
                    <img src={searchIcon} alt='searchIcon' className='searchIconStyle' />
                  </div>
                )}
                {filterComponent}
              </div>
            ) :
            <div className='tabHeaderRightContainerEmpty'>
            </div>}
          </>
        ) : (
          <div className='tabsHeaderSearchExpandedContainer' style={{ display: "flex", alignItems: "center", width: "100%", gap: "10px", flexWrap: "wrap" }}>
            <div className='tabsHeaderSearchExpanded' style={{ flex: "1 1 220px", minWidth: "200px" }}>
              <div className='searchIconContainer'><img src={searchIcon} alt='searchIcon' className='searchIconStyle' /></div>
              <input 
                id="searchBox" 
                type='text' 
                autoFocus 
                onChange={searchOnChange} 
                value={searchValue} 
                placeholder='Search' 
                className='searchInputFieldStyle' 
              />
              <div className='closeIconContainer' onClick={() => {
                setIsSearchActive(false);
                setSearchValue('');
                if (handleSearchDebounce) {
                  handleSearchDebounce('');
                }
              }}>
                <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' />
              </div>
            </div>
            {filterComponent && (
              <div className='tabHeaderRightFilterContainer is-search-active'>
                {filterComponent}
              </div>
            )}
          </div>
        )}
      </div>
      {isMobileScreen && addLabel !== "Add Annoucement" && <div className='tabHeaderDivider' />}
    </div>
  )
}

export default TabsContentHeader;
